import { KVERNELAND_BORDER_RADIUS, KVERNELAND_BOX_SHADOW, KVERNELAND_COLORS, KVERNELAND_FONTS, KVERNELAND_SPACING, } from '../themeConf';
export const notificationsStyle = {
    Containers: {
        DefaultStyle: {
            width: 500,
            top: 'auto',
            bottom: 0,
            margin: '0 auto 0 -250px',
            left: '50%',
        },
    },
    NotificationItem: {
        DefaultStyle: {
            width: 500,
            minHeight: 60,
            height: 'auto',
            border: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingLeft: '5.5em',
            borderRadius: KVERNELAND_BORDER_RADIUS.default,
            boxShadow: KVERNELAND_BOX_SHADOW.default,
        },
        success: {
            backgroundColor: KVERNELAND_COLORS.success.main,
        },
        info: {
            backgroundColor: KVERNELAND_COLORS.brand.main,
        },
        error: {
            backgroundColor: KVERNELAND_COLORS.error.main,
        },
        warning: {
            backgroundColor: KVERNELAND_COLORS.warning.main,
        },
    },
    Dismiss: {
        DefaultStyle: {
            display: 'none',
        },
    },
    Title: {
        DefaultStyle: {
            color: KVERNELAND_COLORS.font.light,
            fontSize: KVERNELAND_FONTS.size.mediumBig,
            fontWeight: KVERNELAND_FONTS.weight.bold,
            height: KVERNELAND_FONTS.size.mediumBig,
            marginBottom: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
    MessageWrapper: {
        DefaultStyle: {
            minHeight: 20,
            fontSize: KVERNELAND_FONTS.size.medium,
            fontWeight: KVERNELAND_FONTS.weight.normal,
            lineHeight: 1.67,
            textAlign: 'left',
            color: KVERNELAND_COLORS.font.light,
            marginTop: KVERNELAND_SPACING.margin.smallest,
        },
    },
};
//# sourceMappingURL=notificationsStyle.js.map